export default __webpack_public_path__ + "static/media/pozadie.a0bca3c4.png";